import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
const CreditorSelector = (props) => {
    const allCreditorsLoadable = useAllCreditors();
    const allCreditors = h.hasData(allCreditorsLoadable)
        ? allCreditorsLoadable.data
        : null;
    const lang = useSelector((s) => s.lang);
    if (!allCreditors) {
        return null;
    }
    return (React.createElement(Select, { value: props.selected
            .map((c) => allCreditors.find((ac) => ac.creditorId === c) || null)
            .filter((c) => !!c)
            .map((c) => ({ label: c.name, value: c.creditorId })), placeholder: lang.users.selectCreditors, isMulti: true, name: lang.users.creditors, options: allCreditors.map((creditor) => {
            return {
                label: creditor.name,
                value: creditor.creditorId,
            };
        }), className: "creditors-select", classNamePrefix: "select", styles: {
            container: (base) => ({ ...base, marginBottom: '20px' }),
        }, onChange: (val) => {
            if (Array.isArray(val)) {
                props.onSelect(val.map((c) => c.value));
            }
        } }));
};
export default CreditorSelector;
//# sourceMappingURL=CreditorSelector.js.map